import { ReactElement } from 'react'
import HotDimensioningCheckSettingsFormFields from '@editor/components/CheckSettingsFormFields/HotDimensioningCheckSettingsFormFields'
import MultiEditCheckSettings from '../MultiEditCheckSettings'
import { MultiEditCheckSettingsElement } from '../MultiEditCheckSettings/types'
import {
  buildHotDimensioningSettingsRow,
  getHotDimensioningSettings,
  hotDimensioningSettingsColumns,
  isHotDimensioningFormValid,
  mergeHotDimensioningSettings,
  normalizeSettings,
} from './utils'
import { hotDimensioningMultiEditSchema } from './validationSchema'

interface Props {
  elements: MultiEditCheckSettingsElement[]
}

const MultiEditHotDimensioning = ({ elements }: Props): ReactElement => (
  <MultiEditCheckSettings
    elements={elements}
    sectionKey="hotDimensioning"
    settingsLabel="Heißbemessungs-Einstellungen"
    getSettings={getHotDimensioningSettings}
    normalizeSettings={normalizeSettings}
    mergeSettings={mergeHotDimensioningSettings}
    differingSettingsMessage="Elemente haben unterschiedliche Heißbemessungs-Einstellungen"
    isFormValid={isHotDimensioningFormValid}
    validationSchema={hotDimensioningMultiEditSchema}
    settingsColumns={hotDimensioningSettingsColumns}
    buildSettingsRow={buildHotDimensioningSettingsRow}
    data-cy="hot-dimensioning-form"
    changeButtonDataCy="hot-dimensioning-change-button"
    fields={
      <HotDimensioningCheckSettingsFormFields memberCheckSettingsSelectedPath="sharedSettings" />
    }
  />
)

export default MultiEditHotDimensioning
